import { useState, type ReactElement } from 'react'
import { Head } from '@inertiajs/react'
import { FileText } from 'lucide-react'
import { artifactCopy as copy } from '@/frontend/features/AgentChats/artifacts/copy'
import { DocumentPreview } from '@/frontend/features/AgentChats/artifacts/DocumentPreview'
import { DocumentToolbar } from '@/frontend/features/AgentChats/artifacts/DocumentToolbar'
import type { AgentChatAttachment } from '@/frontend/pages/Dashboard/AgentChats/types'

export default function Artifact({ attachment }: { attachment: AgentChatAttachment }) {
  const [source, setSource] = useState(false)
  return <main className="flex h-dvh flex-col bg-background text-foreground">
    <Head title={attachment.filename} />
    <header className="flex min-w-0 items-center gap-3 border-b border-border px-5 py-4">
      <FileText aria-hidden="true" className="size-5 shrink-0 text-agent" />
      <div className="min-w-0"><h1 className="truncate text-sm font-semibold">{attachment.filename}</h1><p className="text-xs text-muted-foreground">{copy.private}</p></div>
    </header>
    <DocumentToolbar attachment={attachment} source={source} onSourceChange={setSource} standalone />
    <div className="min-h-0 flex-1 overflow-auto"><DocumentPreview attachment={attachment} source={source} /></div>
  </main>
}

// The authenticated viewer is a standalone document, including in a new tab.
Artifact.layout = (page: ReactElement) => page
